import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../modules/material/material.module';
import { CommonModule } from '@angular/common';
import { TagsFilterComponent } from './components/tags-filter/tags-filter.component';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, TranslateModule],
  providers: [],
  exports: [TagsFilterComponent, ConfirmationDialogComponent],
  entryComponents: [ConfirmationDialogComponent],
  declarations: [TagsFilterComponent, ConfirmationDialogComponent]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts